/**
 * Maintenance-page copy. Three variants cover the operational shapes:
 *
 *   - `default` — generic short-window message; the page renders this when
 *     no explicit variant is requested
 *   - `longOutage` — extended-window reassurance, lifted out of `default`
 *     so the Storybook matrix has a visible distinction without the
 *     component branching on duration
 *   - `planned` — pre-announced maintenance window; subtly different
 *     framing ("planned" vs "scheduled")
 *
 * Copy lives here (not inline) so the page stays presentational and the
 * 3-variant Storybook matrix can consume the same constants — guarantees
 * the visual review surface matches what ships.
 */

export type MaintenanceVariant = 'default' | 'longOutage' | 'planned';

export const MAINTENANCE_COPY: Record<MaintenanceVariant, { heading: string; body: string }> = {
  default: {
    heading: "We'll be back shortly",
    body: 'Cotality Marketplace is undergoing scheduled maintenance.',
  },
  longOutage: {
    heading: 'Extended maintenance window',
    body: 'Cotality Marketplace will return as soon as the platform team completes the planned work. Thanks for your patience.',
  },
  planned: {
    heading: 'Planned maintenance window',
    body: 'Cotality Marketplace is offline for planned maintenance. Please check back soon.',
  },
};
